var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "dropdown lang_dropdown" }, [
    _c(
      "button",
      {
        staticClass: "btn dropdown-toggle",
        attrs: {
          type: "button",
          id: "langDropdown",
          "data-toggle": "dropdown",
          "aria-haspopup": "true",
          "aria-expanded": "false",
        },
      },
      [
        _c(
          "svg",
          {
            attrs: {
              xmlns: "http://www.w3.org/2000/svg",
              width: "24",
              height: "24",
              viewBox: "0 0 24 24",
              fill: "none",
            },
          },
          [
            _c("path", {
              attrs: {
                d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z",
                stroke: "#1D5166",
                "stroke-width": "1.5",
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
              },
            }),
            _vm._v(" "),
            _c("path", {
              attrs: {
                d: "M7.99961 3H8.99961C7.04961 8.84 7.04961 15.16 8.99961 21H7.99961",
                stroke: "#1D5166",
                "stroke-width": "1.5",
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
              },
            }),
            _vm._v(" "),
            _c("path", {
              attrs: {
                d: "M15 3C16.95 8.84 16.95 15.16 15 21",
                stroke: "#1D5166",
                "stroke-width": "1.5",
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
              },
            }),
            _vm._v(" "),
            _c("path", {
              attrs: {
                d: "M3 16V15C8.84 16.95 15.16 16.95 21 15V16",
                stroke: "#1D5166",
                "stroke-width": "1.5",
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
              },
            }),
            _vm._v(" "),
            _c("path", {
              attrs: {
                d: "M3 8.99998C8.84 7.04998 15.16 7.04998 21 8.99998",
                stroke: "#1D5166",
                "stroke-width": "1.5",
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
              },
            }),
          ]
        ),
        _vm._v("\n    " + _vm._s(_vm.currentLanguageLabel) + "\n    "),
        _c("i", { staticClass: "fas fa-chevron-down" }),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "dropdown-menu",
        attrs: { "aria-labelledby": "langDropdown" },
      },
      [
        _vm._l(_vm.availableLanguages, function (lang) {
          return _c(
            "a",
            {
              key: lang.code,
              staticClass: "dropdown-item",
              class: { active: _vm.currentLocale === lang.code },
              attrs: { href: "#" },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.switchLanguage(lang.code)
                },
              },
            },
            [_vm._v("\n      " + _vm._s(lang.native_name) + "\n    ")]
          )
        }),
        _vm._v(" "),
        _vm.availableLanguages.length === 0
          ? [
              _c(
                "a",
                {
                  staticClass: "dropdown-item",
                  class: { active: _vm.currentLocale === "ar" },
                  attrs: { href: "#" },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.switchLanguage("ar")
                    },
                  },
                },
                [_vm._v("\n        العربية\n      ")]
              ),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass: "dropdown-item",
                  class: { active: _vm.currentLocale === "en" },
                  attrs: { href: "#" },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.switchLanguage("en")
                    },
                  },
                },
                [_vm._v("\n        English\n      ")]
              ),
            ]
          : _vm._e(),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }